// extracted by mini-css-extract-plugin
export default {"wrap":"ColoredDot_wrap__1MYa0","s":"ColoredDot_s__0bV1g","m":"ColoredDot_m__Jr+Ae","l":"ColoredDot_l__tKw6F","xl":"ColoredDot_xl__XP6EU","xxl":"ColoredDot_xxl__EjaQI"};